var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgComputer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "computer_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#computer_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M1.335 14a.645.645 0 0 1-.475-.192.645.645 0 0 1-.192-.475c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.191h13.333c.189 0 .347.064.475.191a.645.645 0 0 1 .192.475.645.645 0 0 1-.192.475.645.645 0 0 1-.475.192H1.335Zm1.333-2c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.941V3.333c0-.366.13-.68.391-.941.261-.261.575-.392.942-.392h10.667c.366 0 .68.13.941.392.261.26.392.575.392.941v7.334c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392H2.668Zm0-1.333h10.667V3.333H2.668v7.334Z"
}))));
export default SvgComputer;